// Classes compartilhadas pelas telas do Programa de Indicações.
export const CLASSE_INPUT =
  'w-full bg-white dark:bg-slate-800 border border-gray-200 dark:border-slate-700 rounded-lg px-3 py-2 text-sm ' +
  'text-gray-800 dark:text-gray-100 placeholder:text-gray-400 focus:ring-2 focus:ring-primary/20 focus:border-primary ' +
  'outline-none disabled:opacity-60';
export const CLASSE_ROTULO = 'block text-xs font-semibold text-gray-600 dark:text-slate-300 mb-1';
export const CLASSE_BOTAO_PRIMARIO =
  'inline-flex items-center justify-center gap-1.5 px-4 py-2 rounded-lg bg-primary text-white text-sm font-semibold ' +
  'hover:bg-primary/90 disabled:opacity-50 disabled:cursor-not-allowed';
export const CLASSE_BOTAO_SECUNDARIO =
  'inline-flex items-center justify-center gap-1.5 px-4 py-2 rounded-lg border border-gray-200 dark:border-slate-700 ' +
  'text-sm font-semibold text-gray-700 dark:text-slate-200 hover:bg-gray-50 dark:hover:bg-slate-800 disabled:opacity-50';
export const CLASSE_CARTAO = 'bg-white dark:bg-slate-800/60 rounded-xl border border-gray-200 dark:border-slate-700 shadow-sm';
